import React from "react";
import { VStack, Divider, Text, Flex, Box } from "@chakra-ui/react";
import TradeInteractor from "./TradeInteractor";
import {
  ABI,
  CONTRACT_SEPOLIA,
  CONTRACT_POLYGON,
  CONTRACT_ZKEVM,
  CONTRACT_ARB,
  CONTRACT_BASE,
  CONTRACT_SCROLL,
} from "../data/abi.js";
import { getNetwork } from "@wagmi/core";

const Hero = () => {
  const { chain } = getNetwork();
  let blockchain = "";
  let contract = "";
  console.log(chain);
  if (chain) {
    if (chain.name === "Polygon zkEVM Testnet") {
      blockchain = "zkevm";
      contract = CONTRACT_ZKEVM;
    } else if (chain.name === "Arbitrum Stylus") {
      blockchain = "arbitrum";
      contract = CONTRACT_ARB;
    } else if (chain.name === "Base") {
      blockchain = "base";
      contract = CONTRACT_BASE;
    } else if (chain.name === "Scroll Testnet") {
      blockchain = "scroll";
      contract = CONTRACT_SCROLL;
    } else if (chain.name === "Optimism") {
      blockchain = "optimism";
    } else if (chain.name === "Polygon") {
      blockchain = "polygon";
      contract = CONTRACT_POLYGON;
    } else if (chain.name === "Sepolia") {
      blockchain = "sepolia";
      contract = CONTRACT_SEPOLIA;
    }
  }
  console.log({ blockchain });

  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      minH="60vh"
    >
      <VStack spacing={9}>
        <Box>
          <Flex justifyContent="center" alignItems="center">
            <Text
              fontSize={["3xl", "4xl", "7xl"]}
              fontWeight="bold"
              letterSpacing="-0.02em"
              textShadow="sm"
              lineHeight={["initial", "2rem", "5rem"]}
              /* my="1px" */
              as="h1"
              bgGradient="linear(to-tr, teal.300, purple.500)"
              bgClip="text"
            >
              Swirlio
            </Text>
          </Flex>
          {/*           <Text
            textAlign="center"
            fontSize={['md', 'xl', '4xl']}
            fontWeight="bold"
            letterSpacing="-0.02em"
            textShadow="sm"
            lineHeight={['initial', '1rem', '4rem']}
            justifyContent="center"
            as="h2"
          >
            like never before
          </Text> */}
        </Box>
        <VStack
          spacing={3}
          p={6}
          /* mt="9"  */ borderRadius="lg"
          boxShadow="lg"
          maxWidth="600px"
          w="100%"
        >
          {/* <Text as="h3" fontSize={['xl', '2xl', '3xl']} fontWeight="bold">Offers Feed</Text> */}
          <Divider />
          <TradeInteractor contractAddress={contract} abi={ABI} />
          {/*           <Divider /> */}
        </VStack>
      </VStack>
    </Flex>
  );
};

export default Hero;
